///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promo_campaigns = abcsetup.brand_promo_campaigns || {};
abcsetup.brand_promo_campaigns.edit = abcsetup.brand_promo_campaigns.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promo_campaigns.edit = {
        reservedDatesWithReasons: {},
        availableCampaignQuantities: {},
        selectedDatesCount: {},
        businessHours: [],
        shouldUseBusinessHours: [],
    init: function() {
        // Find and hide the comments section initially
        let commentsWrapper = $('#app_models_brand_promo_campaign_advertisement_advertisement_ad_campaign_comments').closest('div.form-group');
        const originalStartDate = $('.campaign-start-date').val();
        commentsWrapper.hide();
        $('select[name$="reserved_date_override"]').hide();

        // If the "Other" option is already selected on page load, show the comments section
        if ($('input[name="ad_campaign_divisions[]"]:checked').filter(function () {
            return $(this).val() === 'Other';
        }).length) {
            commentsWrapper.show();
            commentsWrapper.find('textarea').prop('required', true);
        }

        abcsetup.brand_promo_campaigns.edit.initializeDateCheckingData();

        // Fetches end date based on start date and campaign type.
        $('.campaign-start-date, .ad-campaign-start-date').on('change', function(event) {
            var field = $(this);
            var start_date = field.val();
            var campaign_type = $('#campaign_type').val();

            // First check date validity and restrictions
            if (abcsetup.brand_promo_campaigns.edit.validateDate(field, start_date, campaign_type)) {
                // If date is valid, get the campaign end date
                abcsetup.brand_promo_campaigns.edit._getCampaignEndDate(start_date, campaign_type);
            }
        });

        // Event handler for changes to the ad_campaign_divisions[] checkboxes
        $(document).on("change", 'input[name="ad_campaign_divisions[]"]', function () {
            let $this = $(this);
            let isOtherChecked = $this.is(':checked') && $this.val() === 'Other';

            // Show the comments section and mark textarea as required if "Other" is selected
            if (isOtherChecked) {
                commentsWrapper.show();
                commentsWrapper.find('textarea').prop('required', true);
            } else {
                // If "Other" is unchecked, hide the comments section and clear the textarea value
                if (!$('input[name="ad_campaign_divisions[]"]:checked').filter(function () {
                    return $(this).val() === 'Other';
                }).length) {
                    commentsWrapper.hide();
                    commentsWrapper.find('textarea').prop('required', false).val('');
                }
            }
        });

        // Handle reserved date override changes
        $(document).on("change", 'select[name$="reserved_date_override"]', function() {
            let $this = $(this);
            
            if ($this.val() === "0") {
                $('.campaign-start-date, .ad-campaign-start-date').val(originalStartDate);
                $this.hide();
                $this.prev('label.custom-label').hide();
            } else if ($this.val() === "1") {
                $this.hide();
                $this.prev('label.custom-label').hide();
                // Proceed with the selected date
                let start_date = $('.campaign-start-date, .ad-campaign-start-date').val();
                let campaign_type = $('#campaign_type').val() || abcsetup.brand_promo_campaigns.edit.extractCampaignType();
                abcsetup.brand_promo_campaigns.edit._getCampaignEndDate(start_date, campaign_type);
            }
        });

    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function () {
        abcsetup.brand_promo_campaigns.common.bindFormElems();
    },

    /**
     *  Get Campaign End Date based on type
     *
     * @param {*} field
     */
    _getCampaignEndDate: function(start_date, campaign_type) {
        abcsetup.blockUI();
            axios.post('/api/brand_promos/get_campaign_end_date', { start_date: start_date, campaign_type: campaign_type }).then(response => {
                abcsetup.unblockUI();
                if (response.data) {
                    $('.campaign-end-date').val(response.data.end_date);
                }
            });
    },

    /**
     * Extracts the campaign type ID from the hidden input
     *
     */
    extractCampaignType: function() {
        return $('#campaign_type').val();
    },

    initializeDateCheckingData: function() {
        // Fetch initial data needed for date validation
        const campaignType = abcsetup.brand_promo_campaigns.edit.extractCampaignType();
        if (campaignType) {
            axios.post('/api/brand_promos/get_campaign_options', { campaign_type_id: campaignType })
                .then((response) => {
                    if (response.data) {
                        this.reservedDatesWithReasons[campaignType] = response.data.reservedDatesWithReasons;
                        this.businessHours[campaignType] = response.data.businessHours;
                        this.shouldUseBusinessHours[campaignType] = response.data.shouldUseBusinessHours;
                        
                        // Initialize available quantities
                        if (!this.availableCampaignQuantities[campaignType]) {
                            this.availableCampaignQuantities[campaignType] = {};
                        }
                        for (const date in response.data.availableCampaignQuantities) {
                            this.availableCampaignQuantities[campaignType][date] = 
                                response.data.availableCampaignQuantities[date] === null ? null : response.data.availableCampaignQuantities[date];
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error fetching campaign options:', error);
                });
        }
    },

    validateDate: function(field, start_date, campaign_type) {
        if (!start_date || !campaign_type) return false;

        const startMoment = moment(start_date);
        if (!startMoment.isValid()) return false;

        const formattedDate = startMoment.format('YYYY-MM-DD');
        
        // Check if date is in the past
        // if (moment().diff(startMoment, 'days') > 0) {
        //     alert("Start date must be in the future.");
        //     field.val('').focus();
        //     return false;
        // }

        // Check business hours if applicable
        if (this.shouldUseBusinessHours[campaign_type] && 
            this.businessHours[campaign_type] && 
            !this.withinBusinessHours(startMoment, campaign_type)) {
            alert(`${startMoment.format('l')} is outside campaign availability. Please select another date.`);
            field.val('').focus();
            return false;
        }

        // Check reserved dates
        const reservedDateInfo = this.reservedDatesWithReasons[campaign_type]?.[formattedDate];
        if (reservedDateInfo) {
            // Show reserved date override options whenever a reserved date is selected
            const reservedDateOverride = $('select[name$="reserved_date_override"]');
            let customLabel = $('label.custom-label');
            
            const labelText = reservedDateInfo.reason
                ? `This date ${startMoment.format('MM/DD/YYYY')} is already reserved for ${reservedDateInfo.reason}. Do you want to fill the reserved date with this campaign?`
                : `This date ${startMoment.format('MM/DD/YYYY')} is already reserved. Do you want to fill the reserved date with this campaign?`;

            // If the custom label doesn't exist, create it
            if (customLabel.length === 0) {
                customLabel = $('<label>', {
                    for: `${reservedDateOverride.attr('id')}_custom`,
                    class: 'custom-label',
                    style: 'color: #ff0000'
                });
                reservedDateOverride.before(customLabel);
            }

            customLabel.text(labelText).show();
            reservedDateOverride.val('').show();
            return false;
        }

        const reservedDateOverride = $('select[name$="reserved_date_override"]');
        const customLabel = $('label.custom-label');
        reservedDateOverride.hide();
        customLabel.hide();

        return true;
    },

    withinBusinessHours: function(date, campaign_type) {
        if (!this.shouldUseBusinessHours[campaign_type] || 
            !this.businessHours[campaign_type] || 
            !Object.keys(this.businessHours[campaign_type]).length) {
            return true;
        }
        return this.businessHours[campaign_type].daysOfWeek.includes(moment(date).day());
    },
}
